<div cdkScrollable style="height: 100%; overflow-y: auto">
    <div class="mb-4">
        <label for="scope">Select a scope:</label>
        <nz-select
            id="scope"
            class="w-full"
            [(ngModel)]="selectedScope"
            (ngModelChange)="onScopeSelect($event)"
        >
            <nz-option
                *ngFor="let scope of displayMessageScopes"
                [nzValue]="scope"
                [nzLabel]="scope"
            ></nz-option>
        </nz-select>
        <nz-select
            *ngIf="selectedScope === 'group'"
            id="group"
            class="w-full mt-4"
            nzPlaceHolder="Select Group"
            [(ngModel)]="selectedGroup"
            (ngModelChange)="onGroupSelect($event)"
        >
            <nz-option
                *ngFor="let group of groups"
                [nzValue]="group"
                [nzLabel]="group"
            ></nz-option>
        </nz-select>
        <label
            *ngIf="selectedScope === 'roles' || selectedScope === 'group'"
            class="block mt-4 mb-1 text-xs text-gray-500"
            >Role</label
        >
        <nz-select
            *ngIf="selectedScope === 'roles' || selectedScope === 'group'"
            class="w-full"
            nzMode="multiple"
            nzPlaceHolder="Select roles"
            [(ngModel)]="selectedRoles"
            (ngModelChange)="onRolesSelect($event)"
        >
            <nz-option
                *ngFor="let option of roleOptions"
                [nzValue]="option.value"
                [nzLabel]="option.label"
            ></nz-option>
        </nz-select>
    </div>

    <div class="mb-4">
        <label for="language">Select a language:</label>
        <nz-select
            id="language"
            class="w-full"
            [(ngModel)]="selectedLanguage"
            (ngModelChange)="onLanguageSelect($event)"
        >
            <nz-option
                *ngFor="let language of languages"
                [nzValue]="language"
                [nzLabel]="language"
            ></nz-option>
        </nz-select>
    </div>

    <div class="mb-4">
        <label for="categoryFilter">Filter by category:</label>
        <div class="flex space-x-2 items-center">
            <nz-select
                id="categoryFilter"
                class="flex-1"
                nzAllowClear
                nzPlaceHolder="All categories"
                [(ngModel)]="selectedCategory"
                (ngModelChange)="onCategorySelect($event)"
            >
                <nz-option
                    *ngFor="let category of categories"
                    [nzValue]="category.name"
                    [nzLabel]="category.name"
                ></nz-option>
            </nz-select>
            <button
                nz-button
                nzType="default"
                (click)="showManageCategories = !showManageCategories"
            >
                {{ showManageCategories ? 'Hide' : 'Manage' }}
            </button>
        </div>
        <div *ngIf="showManageCategories" class="mt-2">
        <div class="flex space-x-2 mt-1">
            <input
                nz-input
                placeholder="New category name"
                [(ngModel)]="newCategoryName"
                (keyup.enter)="addCategory()"
            />
            <button nz-button nzType="default" (click)="addCategory()">
                Add
            </button>
        </div>
        <div
            *ngFor="let category of categories"
            class="flex items-center justify-between mt-2"
        >
            <ng-container
                *ngIf="editingCategoryId === category._id; else viewCategory"
            >
                <input
                    nz-input
                    class="mr-2"
                    [(ngModel)]="editCategoryName"
                    (keyup.enter)="saveCategory(category)"
                />
                <span class="flex space-x-1">
                    <button
                        nz-button
                        nzType="text"
                        nzSize="small"
                        (click)="saveCategory(category)"
                    >
                        <i class="fas fa-check text-green-600"></i>
                    </button>
                    <button
                        nz-button
                        nzType="text"
                        nzSize="small"
                        (click)="cancelEditCategory()"
                    >
                        <i class="fas fa-xmark"></i>
                    </button>
                </span>
            </ng-container>
            <ng-template #viewCategory>
                <span>{{ category.name }}</span>
                <span class="flex space-x-1">
                    <button
                        nz-button
                        nzType="text"
                        nzSize="small"
                        (click)="startEditCategory(category)"
                    >
                        <i class="fas fa-pen-to-square"></i>
                    </button>
                    <button
                        nz-button
                        nzType="text"
                        nzSize="small"
                        nz-popconfirm
                        nzPopconfirmTitle="Delete this category?"
                        nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="deleteCategory(category)"
                    >
                        <i class="fas fa-trash text-red-500"></i>
                    </button>
                </span>
            </ng-template>
        </div>
        </div>
    </div>

    <div *ngFor="let group of groupedMessages" class="role-group">
        <span
            *ngIf="group.label"
            class="role-group-header inline-flex items-center mt-3 mb-2 px-2 py-1 text-xs font-normal text-gray-600 bg-gray-100 rounded"
        >
            <i class="fas fa-filter mr-1 text-gray-400" aria-hidden="true"></i>
            {{ group.label }}
        </span>
        <div
            *ngFor="let message of group.messages"
            class="message-item p-2 border-b border-gray-300"
        >
            <div class="flex items-start justify-between">
                <div
                    class="cursor-pointer flex-1"
                    style="min-width: 0"
                    (click)="openMessage(message)"
                >
                    <p class="nameHeader mb-0">{{ message.name }}</p>
                    <p
                        class="mb-0"
                        style="
                            font-size: 11px;
                            font-weight: 400;
                            color: #9ca3af;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        "
                    >
                        {{ contentPreview(message.content) }}
                    </p>
                </div>
                <button
                    nz-button
                    nzType="default"
                    nzSize="small"
                    class="ml-2 flex-shrink-0"
                    (click)="insertMessage(message, $event)"
                >
                    Insert
                </button>
            </div>
        <div
            *ngIf="selectedMessage === message"
            class="message-content p-4 pt-8 border border-gray-300 rounded-lg relative mt-2"
        >
            <div class="message-actions flex space-x-2 absolute top-1 right-2">
                <button
                    nz-button
                    nzType="text"
                    nzSize="small"
                    nz-tooltip
                    nzTooltipTitle="Edit Message"
                    [disabled]="
                        selectedMessage.scopeType !== 'user' && !adminAccess
                    "
                    (click)="
                        editMessage(selectedMessage); $event.stopPropagation()
                    "
                >
                    <i class="fas fa-pen-to-square"></i>
                </button>
                <button
                    nz-button
                    nzType="text"
                    nzSize="small"
                    nz-popconfirm
                    nzPopconfirmTitle="Are you sure you want to delete this message?"
                    nzPopconfirmPlacement="bottom"
                    (nzOnConfirm)="deleteMessage(selectedMessage._id)"
                    [disabled]="
                        selectedMessage.scopeType !== 'user' && !adminAccess
                    "
                    (click)="$event.stopPropagation()"
                >
                    <i class="fas fa-trash text-red-500"></i>
                </button>
            </div>
            <div [innerHTML]="displayContent(selectedMessage.content)"></div>
            <div
                *ngIf="selectedMessage.category || selectedMessage.roles?.length"
                class="mt-2 text-xs"
                (click)="$event.stopPropagation()"
            >
                <span *ngIf="selectedMessage.category" nz-typography nzType="secondary"
                    >Category: {{ selectedMessage.category }}</span
                >
                <span
                    *ngIf="selectedMessage.roles?.length"
                    nz-typography
                    nzType="secondary"
                    class="ml-2"
                    >Roles: {{ selectedMessage.roles.join(', ') }}</span
                >
            </div>
            <div class="mt-4 flex justify-between text-xs">
                <span nz-typography nzType="secondary"
                    >Created At:
                    {{ selectedMessage.createdAt | date: 'short' }}</span
                >
                <span nz-typography nzType="secondary"
                    >Updated At:
                    {{ selectedMessage.updatedAt | date: 'short' }}</span
                >
            </div>
        </div>
        <ng-container
            *ngIf="editMode && editId === message._id"
            [ngTemplateOutlet]="messageForm"
        ></ng-container>
        </div>
    </div>

    <div
        *ngIf="!groupedMessages.length"
        class="py-6 text-center text-sm text-gray-400"
    >
        <ng-container
            *ngIf="selectedScope === 'group' && !selectedGroup; else noMatch"
        >
            Select a group to see its messages.
        </ng-container>
        <ng-template #noMatch>
            No canned messages match your filters.
        </ng-template>
    </div>

    <div class="mb-4 mt-4">
        <button
            nz-button
            nzType="primary"
            nzShape="round"
            (click)="openCreateMode()"
        >
            Add Message
        </button>
    </div>

    <ng-container
        *ngIf="createMode"
        [ngTemplateOutlet]="messageForm"
    ></ng-container>

    <ng-template #messageForm>
    <div class="mb-4 p-4 border rounded-lg shadow-sm">
        <form
            nz-form
            [formGroup]="validateForm"
            (ngSubmit)="
                saveMessage(editMode ? editId : null, validateForm.value)
            "
        >
            <div class="mb-4">
                <nz-form-item>
                    <nz-form-label [nzFor]="'name'">Message Name</nz-form-label>
                    <nz-form-control
                        [nzErrorTip]="'Please enter a message name'"
                    >
                        <input
                            nz-input
                            type="text"
                            placeholder="Enter message name"
                            formControlName="name"
                            required
                            class="w-full"
                        />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div class="mb-4">
                <nz-form-item>
                    <nz-form-label [nzFor]="'content'"
                        >Message Content</nz-form-label
                    >
                    <nz-form-control
                        [nzErrorTip]="'Please enter message content'"
                    >
                        <ngx-editor-menu
                            [editor]="editor"
                            [toolbar]="toolbar"
                        ></ngx-editor-menu>
                        <ngx-editor
                            [editor]="editor"
                            formControlName="content"
                            placeholder="Enter message content"
                            required
                            class="w-full"
                        ></ngx-editor>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div class="mb-4">
                <nz-form-item>
                    <nz-form-label [nzFor]="'placeholder'"
                        >Insert Placeholder</nz-form-label
                    >
                    <nz-form-control>
                        <nz-select
                            class="w-full"
                            nzPlaceHolder="Select Placeholder"
                            formControlName="placeholder"
                        >
                            <nz-option
                                *ngFor="let option of placeholderOptions"
                                [nzValue]="option.value"
                                [nzLabel]="option.label"
                            ></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div class="mb-4">
                <nz-form-item>
                    <nz-form-label>Select a scope</nz-form-label>
                    <nz-form-control [nzErrorTip]="'Please select a scope'">
                        <nz-radio-group formControlName="scopeType" required>
                            <label
                                *ngFor="let scope of newMessageScopes"
                                nz-radio-button
                                [nzValue]="scope"
                                type="button"
                            >
                                {{ scope }}
                            </label>
                        </nz-radio-group>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item *ngIf="newMessageScope === 'group'">
                    <nz-form-label [nzFor]="'newMessageGroup'"
                        >Select a group</nz-form-label
                    >
                    <nz-form-control [nzErrorTip]="'Please select a group'">
                        <nz-select
                            class="w-full"
                            formControlName="groupName"
                            nzPlaceHolder="Select Group"
                            required
                        >
                            <nz-option
                                *ngFor="let group of groups"
                                [nzValue]="group"
                                [nzLabel]="group"
                            ></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item
                    *ngIf="
                        newMessageScope === 'group' || newMessageScope === 'role'
                    "
                >
                    <nz-form-label [nzFor]="'roles'">Role</nz-form-label>
                    <nz-form-control>
                        <nz-select
                            class="w-full"
                            nzMode="multiple"
                            formControlName="roles"
                            nzPlaceHolder="Leave empty to show to everyone"
                        >
                            <nz-option
                                *ngFor="let option of roleOptions"
                                [nzValue]="option.value"
                                [nzLabel]="option.label"
                            ></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div class="mb-4">
                <nz-form-item>
                    <nz-form-label>Select a language</nz-form-label>
                    <nz-form-control [nzErrorTip]="'Please select a language'">
                        <nz-radio-group formControlName="language" required>
                            <label
                                *ngFor="let language of newMessageLanguages"
                                nz-radio
                                [nzValue]="language"
                                type="radio"
                            >
                                {{ language }}
                            </label>
                        </nz-radio-group>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div class="mb-4">
                <nz-form-item>
                    <nz-form-label [nzFor]="'category'">Category</nz-form-label>
                    <nz-form-control>
                        <div class="flex space-x-2 items-center">
                            <nz-select
                                class="flex-1"
                                formControlName="category"
                                nzAllowClear
                                nzPlaceHolder="Select a category"
                            >
                                <nz-option
                                    *ngFor="let category of categories"
                                    [nzValue]="category.name"
                                    [nzLabel]="category.name"
                                ></nz-option>
                            </nz-select>
                            <button
                                nz-button
                                nzType="default"
                                type="button"
                                (click)="
                                    showAddFormCategory = !showAddFormCategory
                                "
                            >
                                {{ showAddFormCategory ? 'Cancel' : '+ New' }}
                            </button>
                        </div>
                        <div
                            *ngIf="showAddFormCategory"
                            class="flex space-x-2 items-center mt-2"
                        >
                            <input
                                nz-input
                                placeholder="New category name"
                                [(ngModel)]="newFormCategoryName"
                                [ngModelOptions]="{ standalone: true }"
                                (keyup.enter)="addFormCategory()"
                            />
                            <button
                                nz-button
                                nzType="default"
                                type="button"
                                (click)="addFormCategory()"
                            >
                                Add
                            </button>
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <button
                nz-button
                nzType="primary"
                nzShape="round"
                type="submit"
                [disabled]="validateForm.invalid"
            >
                {{ editMode ? 'Save Changes' : 'Save New Message' }}
            </button>
            <button
                nz-button
                nzType="default"
                nzShape="round"
                class="ml-2"
                (click)="resetForm()"
            >
                Cancel
            </button>
        </form>
    </div>
    </ng-template>
</div>
